export const ASSET_PACKAGE_STATUS_OPEN = 1;
export const ASSET_PACKAGE_STATUS_CLOSED = 100;
export const ASSET_PACKAGE_STATUS_DELETED = 7;
export const ASSET_PACKAGE_STATUS_CONTRACTED = 9;
export const ASSET_PACKAGE_STATUS_IN_PRICING = 10;
export const ASSET_PACKAGE_STATUS_SENT_FOR_PRICING = 3;
export const ASSET_PACKAGE_STATUS_SENT_FOR_ALGO_PRICING = 11;
export const ASSET_PACKAGE_STATUS_RESENT_FOR_PRICING = 6;
export const ASSET_PACKAGE_STATUS_PRICING_COMPLETE = 4;
export const ASSET_PACKAGE_STATUS_ON_HOLD = 5;
export const ASSET_PACKAGE_STATUS_SENT_TO_OPERATIONS = 8;
export const ASSET_PACKAGE_STATUS_MERGED = 2;
export const ASSET_PACKAGE_STATUS_CLOSED_LOST=99

export const ASSET_PACKAGE_STATUS_OPEN_DESC = 'Open';
export const ASSET_PACKAGE_STATUS_CLOSED_DESC = 'Closed';
export const ASSET_PACKAGE_STATUS_DELETED_DESC = 'Deleted';
export const ASSET_PACKAGE_STATUS_CONTRACTED_DESC = 'Contracted';
export const ASSET_PACKAGE_STATUS_IN_PRICING_DESC = 'In Pricing';
export const ASSET_PACKAGE_STATUS_SENT_FOR_PRICING_DESC = 'Sent For Pricing';
export const ASSET_PACKAGE_STATUS_RESENT_FOR_PRICING_DESC = 'Resent For Pricing';
export const ASSET_PACKAGE_STATUS_PRICING_COMPLETE_DESC = 'Pricing Complete';
export const ASSET_PACKAGE_STATUS_ON_HOLD_DESC = 'On Hold';
export const ASSET_PACKAGE_STATUS_SENT_TO_OPERATIONS_DESC = 'Sent To Operations';
export const ASSET_PACKAGE_STATUS_MERGED_DESC = 'Merged';
export const ASSET_PACKAGE_STATUS_SENT_FOR_ALGO_PRICING_DESC = 'Sent For Pricing';
export const ASSET_PACKAGE_STATUS_CLOSED_LOST_DESC= 'Closed Lost';

export const assetPackageStatusType = [
  {
    name: ASSET_PACKAGE_STATUS_OPEN_DESC,
    id: ASSET_PACKAGE_STATUS_OPEN
  },
  {
    name: ASSET_PACKAGE_STATUS_CLOSED_DESC,
    id: ASSET_PACKAGE_STATUS_CLOSED
  },
  {
    name: ASSET_PACKAGE_STATUS_DELETED_DESC,
    id: ASSET_PACKAGE_STATUS_DELETED
  },
  {
    name: ASSET_PACKAGE_STATUS_CONTRACTED_DESC,
    id: ASSET_PACKAGE_STATUS_CONTRACTED
  },
  {
    name: ASSET_PACKAGE_STATUS_IN_PRICING_DESC,
    id: ASSET_PACKAGE_STATUS_IN_PRICING
  },
  {
    name: ASSET_PACKAGE_STATUS_SENT_FOR_PRICING_DESC,
    id: ASSET_PACKAGE_STATUS_SENT_FOR_PRICING
  },
  {
    name: ASSET_PACKAGE_STATUS_RESENT_FOR_PRICING_DESC,
    id: ASSET_PACKAGE_STATUS_RESENT_FOR_PRICING
  },
  {
    name: ASSET_PACKAGE_STATUS_PRICING_COMPLETE_DESC,
    id: ASSET_PACKAGE_STATUS_PRICING_COMPLETE
  },
  {
    name: ASSET_PACKAGE_STATUS_ON_HOLD_DESC,
    id: ASSET_PACKAGE_STATUS_ON_HOLD
  },
  {
    name: ASSET_PACKAGE_STATUS_SENT_TO_OPERATIONS_DESC,
    id: ASSET_PACKAGE_STATUS_SENT_TO_OPERATIONS
  },
  {
    name: ASSET_PACKAGE_STATUS_MERGED_DESC,
    id: ASSET_PACKAGE_STATUS_MERGED
  },
  {
    name: ASSET_PACKAGE_STATUS_SENT_FOR_ALGO_PRICING_DESC,
    id: ASSET_PACKAGE_STATUS_SENT_FOR_ALGO_PRICING
  },
  {
    name:ASSET_PACKAGE_STATUS_CLOSED_LOST_DESC,
    id:ASSET_PACKAGE_STATUS_CLOSED_LOST
  }

];
